import React from 'react';
import Icon from '../Icon';
import { SC_IMAGES } from '../../data/images';

const PROCESS = [
  { num: '01', icon: 'document', title: 'Submit your check', body: 'Tell us about your situation in 2 minutes. No SSN. No documents required.' },
  { num: '02', icon: 'users',    title: 'Advocate review',   body: 'A care advocate reviews your answers and identifies the programs that fit.' },
  { num: '03', icon: 'phone',    title: 'Personalized call', body: 'We call you within 24 hours with your eligibility report and next steps.' },
  { num: '04', icon: 'dollar',   title: 'Get paid',          body: 'We prepare every form and stay with you until your first check arrives.' },
];

const EligibilitySupporting = () => (
  <section className="elig-supporting">
    <div className="container">
      <div className="elig-supporting-head">
        <span className="eyebrow">What happens next</span>
        <h2>Submit once. We handle the rest.</h2>
        <p className="lede">
          A real care advocate — not a chatbot — reviews your answers and walks you through every step.
        </p>
      </div>

      <div className="elig-process">
        {PROCESS.map(p => (
          <div className="elig-process-card" key={p.num}>
            <span className="ep-num">{p.num}</span>
            <div className="ep-ic"><Icon name={p.icon} size={20} stroke={1.8}/></div>
            <h3>{p.title}</h3>
            <p>{p.body}</p>
          </div>
        ))}
      </div>

      <div className="elig-trust-grid">
        <div className="elig-trust-card stats">
          <span className="t-eyebrow">By the numbers</span>
          <div className="stat-row"><span>Families helped</span><span className="v">12,400+</span></div>
          <div className="stat-row"><span>Avg. monthly payment</span><span className="v">$3,240</span></div>
          <div className="stat-row"><span>Approval rate</span><span className="v">94%</span></div>
          <div className="stat-row"><span>Median to first check</span><span className="v">14 days</span></div>
        </div>

        <div className="elig-trust-card policy">
          <span className="t-eyebrow">Privacy &amp; trust</span>
          <h4>Your information stays yours.</h4>
          <ul>
            <li><span className="check"><Icon name="check-bold" size={11}/></span>
              We never sell your data — to anyone, ever.</li>
            <li><span className="check"><Icon name="check-bold" size={11}/></span>
              Encrypted with 256-bit SSL end to end.</li>
            <li><span className="check"><Icon name="check-bold" size={11}/></span>
              HIPAA-compliant infrastructure and audits.</li>
            <li><span className="check"><Icon name="check-bold" size={11}/></span>
              Delete your data anytime by emailing us.</li>
          </ul>
        </div>

        <div className="elig-trust-card story">
          <span className="t-eyebrow">A real family</span>
          <blockquote>
            I had no idea I could be paid for caring for my mom. SupportCare handled every form
            and got me approved in 11 days. I'm now earning $2,800 / month.
          </blockquote>
          <div className="who">
            <div className="av" style={{ backgroundImage: `url(${SC_IMAGES.a1 || ''})` }}/>
            <div>
              <div className="nm">Maria R.</div>
              <div className="meta">Daughter caregiver · Sacramento, CA</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default EligibilitySupporting;
